/**
 * PostHog analytics wrapper.
 *
 * PostHog is initialized via /public/index.html (window.posthog).
 * These helpers are safe no-ops if PostHog isn't ready yet — so we can
 * scatter `track()` calls throughout the app without try/catch noise.
 */

const ph = () =>
  typeof window !== "undefined" && window.posthog && typeof window.posthog.capture === "function"
    ? window.posthog
    : null;

/** Capture a custom event with properties. */
export const track = (event, properties = {}) => {
  const p = ph();
  if (!p) return;
  try {
    p.capture(event, properties);
  } catch {
    // never break UX on analytics failure
  }
};

/** Identify a subscriber/customer by email once we have it. */
export const identifyUser = (email, traits = {}) => {
  const p = ph();
  if (!p || !email) return;
  try {
    p.identify(email.toLowerCase().trim(), { email: email.toLowerCase().trim(), ...traits });
  } catch {
    /* noop */
  }
};

/** Reset on logout / clear identity. */
export const resetUser = () => {
  const p = ph();
  if (!p) return;
  try {
    p.reset();
  } catch {
    /* noop */
  }
};

/* Named conversion events — keeping them centralized avoids typos in analytics. */
export const EVENTS = {
  NEWSLETTER_SUBSCRIBED: "newsletter_subscribed",
  FREE_PDF_DOWNLOADED: "free_pdf_downloaded",
  CHECKOUT_INITIATED: "checkout_initiated",
  CHECKOUT_REDIRECTED: "checkout_redirected",
  PURCHASE_COMPLETED: "purchase_completed",
  WAITLIST_JOINED: "waitlist_joined",
  CONTACT_SUBMITTED: "contact_submitted",
  BUY_MODAL_OPENED: "buy_modal_opened",
};
